// extracted by mini-css-extract-plugin
module.exports = {"message":"Sizes_message__2nbbD","heading":"Sizes_heading__L6jXa","groupSizesList":"Sizes_groupSizesList__q6WXD","groupList":"Sizes_groupList__6H87Z"};